export const SESSION_STORAGE_KEYS = {
  USER_REQUESTED_PHONE_STATUS: accountId =>
    `userRequestedPhoneStatus-${accountId}`,
  USER_REQUESTED_PHONE_QUEUE_ACTION: accountId =>
    `userRequestedPhoneQueueAction-${accountId}`,
};
